import { computed, ref } from 'vue';

export const isAccessAllowed = ref();

export const isAgentCashDomain = computed(() => ['agent.stage.cash-service.cc', process.env.AGENTCASH_DOMAIN].includes(window.location.hostname));
